/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchProductsEvents = {
    /**
     * Dispatch product list loaded event
     *
     * @param page
     * @param type
     */
    dispatchProductListLoadedEvent(type, page) {
        window.dispatchEvent(new CustomEvent("product-list-loaded", {
            detail: { type, page }
        }));
    },
    /**
     * Handle product list loaded events
     * Sets up product observation and manages focus/scroll behavior based on event type
     *
     * @param {CustomEvent} event - The product list loaded event
     */
    productListLoadedCallback(event) {
        // Always observe products for any event type
        this.observeProducts();

        const eventType = event.detail.type;

        // Handle initial page load
        if (eventType === "initial") {
            this.handleInitialLoad(event);
        }
        // Handle pagination events
        else if (["next", "previous"].includes(eventType)) {
            this.setFocusOnProduct(event);
        }
    },
    /**
     * Handle initial product list load scenarios
     * Manages returning from product detail pages and non-first page loads
     *
     * @param {CustomEvent} event - The product list loaded event
     * @private
     */
    handleInitialLoad(event) {
        // Case 1: User is returning from a product detail page
        if (this.clickedProductSelector) {
            this.scrollToClickedProduct(this.clickedProductSelector);

            // Update URL if returning to a page other than the first
            if (this.clickedProductPage !== 1) {
                this.setUrlPageParam(this.clickedProductPage);
            }

            // Reset clicked product tracking
            this.clickedProductSelector = "";
            this.clickedProductPage = 1;
        }
        // Case 2: Initial load starting from a page other than the first
        else if (this.pagesCurrent > 1) {
            this.setUrlPageParam(this.pagesCurrent);
            this.setFocusOnProduct(event);
        }
    }
}

export default liveSearchProductsEvents;
